import { render, staticRenderFns } from "./UserContacts.vue?vue&type=template&id=68a5bf40&scoped=true"
import script from "./UserContacts.vue?vue&type=script&lang=js"
export * from "./UserContacts.vue?vue&type=script&lang=js"
import style0 from "./UserContacts.vue?vue&type=style&index=0&id=68a5bf40&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a5bf40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68a5bf40')) {
      api.createRecord('68a5bf40', component.options)
    } else {
      api.reload('68a5bf40', component.options)
    }
    module.hot.accept("./UserContacts.vue?vue&type=template&id=68a5bf40&scoped=true", function () {
      api.rerender('68a5bf40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/assets/UserContacts.vue"
export default component.exports